/**
 * "Affiliate program" on the Settings Profile tab: the way into the
 * anterotrail.com/affiliates application form from inside the app. Settings
 * hides it for a user who already runs an affiliate code (they get the
 * Referrals tab instead).
 */
export const AFFILIATES_URL = 'https://anterotrail.com/affiliates/';

export default function AffiliateInvite() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4" data-testid="affiliate-invite">
      <div className="text-[12.5px] text-[var(--tx-lo)]">
        Refer estimators and earn 20% of what they pay for their first 12 months.
      </div>
      <a
        href={AFFILIATES_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[13px] font-[560] text-[var(--accent)] hover:underline"
      >
        Become an affiliate
      </a>
    </div>
  );
}
